import { Link as RouterLink } from "react-router-dom";
import { Link, Typography } from "@mui/material";
import { pageRoutes } from "../../constants";

export const submitButtonSx = {
  mt: 3,
  py: 1.2,
  borderRadius: 2,
  fontWeight: 600,
  textTransform: "none",
};

export function StepHeader({ title, children }) {
  return (
    <>
      <Typography
        variant="h4"
        sx={{
          letterSpacing: "-1.2px",
          fontWeight: 800,
          mb: 1,
          color: "primary.main",
          textAlign: "center",
        }}
      >
        {title}
      </Typography>

      <Typography sx={{ mb: 3, color: "text.secondary", textAlign: "center" }}>
        {children}
      </Typography>
    </>
  );
}

// An error wins over a notice such as "new code sent"
export function StepMessage({ error, notice }) {
  if (!error && !notice) return null;

  return (
    <Typography
      role={error ? "alert" : "status"}
      color={error ? "error" : "success.main"}
      sx={{ mt: 2, textAlign: "center" }}
    >
      {error || notice}
    </Typography>
  );
}

export function TextButton(props) {
  return (
    <Link
      component="button"
      type="button"
      variant="body2"
      underline="hover"
      sx={{ "&:disabled": { color: "text.disabled", cursor: "default" } }}
      {...props}
    />
  );
}

export function BackToLoginLink() {
  return (
    <Typography variant="body2" sx={{ textAlign: "center" }}>
      <RouterLink to={pageRoutes.LOGIN} style={{ textDecoration: "none" }}>
        ← Back to login
      </RouterLink>
    </Typography>
  );
}
